export const systemInfoConstants = {
    GET_SYSTEM_SUCCESS: 'GET_SYSTEM_SUCCESS',
    GET_SYSTEM_FAILURE: 'GET_SYSTEM_FAILURE',
    CLEAR_SYSTEM_INFO: 'CLEAR_SYSTEM_INFO',
};